import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import NationalFooter from '../../components/national-footer'
import UnifiedHeader from '../../components/unified-header'
import ErrorFeature from '../../components/error-feature'

const Error = ({ status, error }) => (
  <Fragment>
    <UnifiedHeader />
    <main>
      <ErrorFeature error={error} status={status} />
    </main>
    <NationalFooter />
  </Fragment>
)

Error.defaultProps = {
  status: 404,
}

Error.propTypes = {
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  status: PropTypes.number,
}

export default Error
